export class environmentConfig {
  production = false;
  rootUrl = 'http://localhost:4200';
  api = {
    url: 'http://localhost:54033/',
    sameHost: false,
  };
  lazyLoadPageSize = 74;
  baseHref = '/';
  buildVersion = 'http://localhost:4200/assets/config/buildVersion.json';
  DisplayDateFormat = 'MM-dd-yyyy';
  DisplayDateTimeFormat = 'MM-dd-yyyy hh:mm tt';
  minimumCoverage = 90;
}

export const environment: environmentConfig = {
  production: false,
  rootUrl: '',
  api: {
    url: '',
    sameHost: false,
  },
  lazyLoadPageSize: 0,
  baseHref: '',
  buildVersion: 'http://localhost:4200/assets/config/buildVersion.json',
  DisplayDateFormat: 'MM-dd-yyyy',
  DisplayDateTimeFormat: 'MM-dd-yyyy hh:mm tt',
  minimumCoverage: 90
};
